export const blobToFile = (theBlob: Blob, fileName: string): File => {
  // The File constructor takes an array of parts, a filename, and an optional properties object
  return new File([theBlob], fileName, {
    lastModified: new Date().getTime(), // or just use Date.now()
    type: theBlob.type, // preserve the MIME type
  })
}
